
export class RefundTransactionFilter{
    start:string;
    end:string;
    planIDs?:number[];
    refundReason?: string[];
    affiliateIDs: number[] = [];
    transactionSearch: string;
}